// **********************************************************************************


import Button from "../bases/button/button";
import Icon from "../bases/icone/icon.js";
// images
import sidebarmenuclose from "./assets/sidebarmenuclose.png"
import sidebarmenuopen from "./assets/sidebarmenuopen.png"
import accueil from "./assets/accueil.png"
import projets from "./assets/projets.png"
import local from "./assets/local.png"
import externe from "./assets/externe.png"
import soustitrage from "./assets/soustitrage.png"
import soustitres from "./assets/soustitres.png"
import transcription from "./assets/transcription.png"
import parametres from "./assets/parametres.png"
import exporter from "./assets/exporter.png"
import audiodescription from "./assets/audiodescription.png"
import tests from "./assets/tests.png"

import caretbas from "./assets/caretbas.png"
import caretdroit from "./assets/caretdroit.png"
import Tooltip from "../bases/tooltips/tooltip.js";


import getText from "../../utils/language.js"
import { GlobalContext } from '../../utils/globalprovider';
import "./sidebar.css"
import React from "react";

import logo from "../../assets/logoEasyTT.png"

import SimplePopup from "../bases/popup/simplePopup.js";

class IconSideBar extends React.Component
{

    constructor (props)
    {
        super(props);
        this.onClickOnItem = this.onClickOnItem.bind(this);
    }
    onClickOnItem()
    {
        this.props.onClick(this.props.index, this.props.sindex);
    }

    render()
    {
        var className="IconOnlySideBar";
        
        if (this.props.values.link === this.props.selected)
        {
            
            className+=" IconOnlySelectedSideBar";
            
        }
        return (
            <div onClick={this.onClickOnItem} className={className} >
                
                <Tooltip text={this.props.text}>
                <Button image={this.props.values.icon} disable={this.props.values.disable} border={false} width="48px" height="48px"/>
                </Tooltip>
                
           </div>
        )
    }

}

class CatSideBar extends React.Component
{

    constructor (props)
    {
        super(props);
        this.onClickOnItem = this.onClickOnItem.bind(this);
    }
    onClickOnItem()
    {
        this.props.onClick(this.props.index);
    }
    render()
    {
        var className = "catSideBarDefaultItem";
        var classNameSelected = "catScatNoBorderText";
        // recherche de la class
        if (this.props.values.disable)
            className = "catSideBarDisableItem";
        else
            if (this.props.values.link === this.props.selected)
            {
                className = "catSideBarSelectedItem";
                classNameSelected = "catScatBorderText";
            }
            
        var caret = [];
        if (this.props.values.childs.length != 0)
        {
            // caret
            if (this.props.values.extend)
                caret.push(<Button image={caretbas} border={false} disable={this.props.values.disable} width="12px" height="12px"/>)
            else
                caret.push(<Button image={caretdroit} border={false} disable={this.props.values.disable} width="12px" height="12px"/> )

        }
    
    

        className = "catsCatItem " + className;

        return (<div className={className} onClick={this.onClickOnItem}>
            <Button image={this.props.values.icon} disable={this.props.values.disable} border={false} width="24px" height="24px"/>
            
            &nbsp;&nbsp;<span className={classNameSelected}>&nbsp;{this.props.text}&nbsp;</span>
            &nbsp;{caret}
        </div>
            
        )
    }
}

class SCatSideBar extends React.Component
{
    constructor (props)
    {
        super(props);
        this.onClickOnItem = this.onClickOnItem.bind(this);
    }

    onClickOnItem()
    {
        this.props.onClick(this.props.index, this.props.sindex);
    }

    render()
    {
        var className = "scatSideBarDefaultItem";
        var classNameSelected = "catScatNoBorderText";

        // recherche de la class
        if (this.props.values.disable)
            className = "scatSideBarDisableItem";
        else
        if (this.props.values.link === this.props.selected)
        {
            className = "scatSideBarSelectedItem";
            classNameSelected = "catScatBorderText";
        }


        

        className = "catsCatItem " + className;

        return (<div className={className}  onClick={this.onClickOnItem}>
            <Button image={this.props.values.icon} border={false} disable={this.props.values.disable} width="24px" height="24px"/>
            &nbsp;&nbsp;<span className={classNameSelected}>&nbsp;{this.props.text}&nbsp;</span>
        </div>
            
        )
    }
}



class SideBar extends React.Component
{

    static contextType = GlobalContext;
    constructor (props)
    {
        super(props);
        this.state = {
            open: false, // ouverture du menu à gauche
            iconsopen: false, // ouverture du menu icon en bas
            selected: "home",
            savePopup: false, // true if unsaved datas
            menu: [
                {icon: accueil, disable:false, text:{cat:0,scat: 0}, link:"home", extend:false, selected: false, minmenu: true, childs:[]},
                {icon: projets, disable:true, text:{cat:0,scat: 1}, link:"projects", extend:true, selected: false, 
                    childs:[
                        {icon: local, disable:true, text:{cat:0,scat: 2}, link:"localprojects",  selected: false, minmenu: true},
                        {icon: externe, disable:true, text:{cat:0,scat: 3}, link:"externalprojects",  selected: false, minmenu: true},
                    ]
                },
                {icon: soustitrage, disable:true, text:{cat:0,scat: 4}, link:"subtitling", extend:true, selected: false, minmenu: true, 
                    childs:[
                        {icon: transcription, disable:true, text:{cat:0,scat: 5}, link:"transcription",  selected: false, minmenu: true},
                        {icon: soustitres, disable:true, text:{cat:0,scat: 6}, link:"subtitles",  selected: false, minmenu: true},
                        {icon: audiodescription, disable:true, text:{cat:0,scat: 11}, link:"audiodescription",  selected: false, minmenu: true},
                    ]
                },
                {icon: exporter, disable:true, text:{cat:0,scat: 7}, link:"exports", extend:false, selected: false, minmenu: true, childs:[]},
                {icon: parametres, disable:true, text:{cat:0,scat: 8}, link:"settings", extend:false, selected: false, minmenu: true, childs:[]},
                {icon: tests, disable:true, text:{cat:0,scat: 12}, link:"tests", extend:false, selected: false, minmenu: true, childs:[]},
            ]



        }
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);        
        this.gotoRoute = this.gotoRoute.bind(this);
        this.onClickOnMenu = this.onClickOnMenu.bind(this);
        this.onClickOnIcon = this.onClickOnIcon.bind(this);
        this.onClickOnCat = this.onClickOnCat.bind(this);
        this.onClickOnSCat = this.onClickOnSCat.bind(this);
        this.onDontQuit = this.onDontQuit.bind(this);
        this.onDontSaveAndQuit = this.onDontSaveAndQuit.bind(this);


        this.onEnterMenuDown = this.onEnterMenuDown.bind(this);
        this.onLeaveMenuDown = this.onLeaveMenuDown.bind(this)

    }


    onEnterMenuDown()
    {
        
        this.setState(
            { open: false,
            iconsopen:true,
            }
        )
    }
    onLeaveMenuDown()
    {
        this.setState(
            { open: false,
            iconsopen:false,
            }
        )
    }

    disableAll(menu)
    {
        for (var i=0 ; i < menu.length; i++)
        {
            menu[i].disable = true;
            menu[i].selected = false;
            for (var j = 0 ; j < menu[i].childs.length; j++)
            {
                menu[i].childs[j].disable=true;
                menu[i].childs[j].selected=false;
            }
        }

    }

    enabledItem(menu,item)
    {
        for (var i=0 ; i < menu.length; i++)
            {
                if (menu[i].link == item) menu[i].disable = false;
                for (var j=0 ; j < menu[i].childs.length; j++)
                    if (menu[i].childs[j].link == item) menu[i].childs[j].disable=false;
            }
    
    }


    disableItem(menu,item)
    {
        for (var i=0 ; i < menu.length; i++)
            {
                if (menu[i].link == item) menu[i].disable = true;
                for (var j=0 ; j < menu[i].childs.length; j++)
                    if (menu[i].childs[j].link == item) menu[i].childs[j].disable=true;
            }
    
    }


    projectClose()
    {
        var menu = this.state.menu;
        this.disableItem(menu, "subtitling");
        this.disableItem(menu, "transcription");
        this.disableItem(menu, "subtitles");
        this.disableItem(menu, "audiodescription");

        this.disableItem(menu, "exports");
        this.disableItem(menu, "tests");

        this.setState({menu: menu})

    }


    projectOpen()
    {
        var menu = this.state.menu;
        this.enabledItem(menu, "subtitling");
        this.enabledItem(menu, "transcription");
        this.enabledItem(menu, "subtitles");
        this.enabledItem(menu, "audiodescription");
        this.enabledItem(menu, "exports");
        this.enabledItem(menu, "tests");

        this.setState({menu: menu})

    }

    setMenuState(statename)
    {

        var menu = this.state.menu;
        var selected="home";
        
        switch (statename)
        {
            case "login":
                this.disableAll(menu);
                this.enabledItem (menu,"home");
                this.enabledItem(menu, "projects");
                this.enabledItem (menu,"localprojects");
                this.enabledItem (menu,"settings");
                selected ="localprojects";
                break;

            case "logout":
                this.disableAll(menu);
                this.enabledItem (menu,"home");
                selected ="home";
                break;

            case "local":
                this.enabledItem(menu,"localprojects");
                this.enabledItem(menu,"projects");
                selected="localprojects";
                break;
            default:
                selected = statename.route;
                break;
    
        }
        this.setState({open: false, iconsopen: false, menu: menu, selected: selected});


    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
      }
    
      componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
      }
    
      /**
       * Alert if clicked on outside of element
       */
      handleClickOutside(event) {
        
        
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.setState({open: false});
        }
      }

    gotoRoute(route)
    {
        
        this.setMenuState({route})
        this.props.onNavigate(route);
    }

    onClickOnMenu()
    {
        
        this.setState({open: !this.state.open});
    }

    checkIfCanChangeItem(route)
    {
        if (this.props.onCheckCanClose()) return true;
        this.newroute = route;
        this.setState({savePopup: true});
        return false;
    }


    onClickOnIcon(cat, scat)
    {
        if (scat == -1)   
        {
            if (this.state.menu[cat].disable) return;
            if (!this.checkIfCanChangeItem(this.state.menu[cat].link)) return;

            
            // ici on peut router
            this.setState(
                {selected: this.state.menu[cat].link,
                    open:false,
                    iconsopen:false,
                    
                }
            )
            this.gotoRoute (this.state.menu[cat].link);


        }
        else
        {
            if (this.state.menu[cat].childs[scat].disable) return;
            if (!this.checkIfCanChangeItem(this.state.menu[cat].childs[scat].link)) return;
            // ici on peut router
            
            this.setState(
                {selected: this.state.menu[cat].childs[scat].link,
                    open:false,
                }
            )
            this.gotoRoute (this.state.menu[cat].childs[scat].link);

        }
    }



    onClickOnCat(cat)
    {

        var menu = this.state.menu;
        
        if (menu[cat].childs.length != 0)
        {
            menu[cat].extend = !menu[cat].extend;
            this.setState({menu: menu});
        }
        else
        {
            if ((!menu[cat].disable) && (menu[cat].link != this.state.selected))
            {
                // ici on peut router
                if (!this.checkIfCanChangeItem(menu[cat].link)) return;
                this.setState(
                    {selected: menu[cat].link,
                        open:false,
                        iconsopen:false,
                    }
                )
                this.gotoRoute (menu[cat].link);
                

            }
        }
    }

    onClickOnSCat(cat, scat)
    {
        var menu = this.state.menu;
        if ((!menu[cat].childs[scat].disable) && (menu[cat].childs[scat].link != this.state.selected))
        {
            if (!this.checkIfCanChangeItem(menu[cat].childs[scat].link)) return;
            this.setState(
                {selected: menu[cat].childs[scat].link,
                    open:false,
                }
            )
            this.gotoRoute (menu[cat].childs[scat].link);

        }


    }

    onDontQuit()
    {
        this.setState({savePopup:false});
    }
    onDontSaveAndQuit()
    {
        this.setState({savePopup:false, open:false, selected: this.newroute});
        this.gotoRoute (this.newroute);
    }


    render()
    {


        /*



        */

        var popup =[];

            var titlePopup = getText(2,0,this.context.language);
            var textPopup = getText(1,0,this.context.language);
            var bouton1 = getText(1,1,this.context.language);
            var bouton2 = getText(1,2,this.context.language);

            var bouton1  = {fr:bouton1, en:bouton1};
            var bouton2  = {fr:bouton2, en:bouton2};

            var titlePopup = {fr:titlePopup, en:titlePopup};
            var textPopup = {fr:textPopup, en:textPopup};


            popup.push(<SimplePopup display={this.state.savePopup} title="" text={textPopup} onCancel={this.onDontQuit}
                buttons ={[{text:bouton1,onclick:this.onDontSaveAndQuit},{text:bouton2,onclick:this.onDontQuit}]} />);



        var menu=[];
        var tipmenu = "";
        if (this.state.open) // Menu Texte Ouvert
        {
            for (var i=0 ; i < this.state.menu.length; i++)
            {
                var cat = this.state.menu[i];
                var text = getText(cat.text.cat,cat.text.scat,this.context.language);


                menu.push(<CatSideBar values={cat} index={i} text={text} selected={this.state.selected} onClick={this.onClickOnCat}/>);
                if ((cat.extend) && (cat.childs.length !== 0))
                {
                    
                    for (var j=0; j<cat.childs.length; j++)
                    {
                        var scat = cat.childs[j];
                        text = getText(scat.text.cat,scat.text.scat,this.context.language);
                        menu.push(<SCatSideBar values={cat.childs[j]} index={i} sindex={j} text={text} selected={this.state.selected} onClick={this.onClickOnSCat}/>);
                    }
                }
            }
            tipmenu = getText(0,10,this.context.language);
        }
        else
        {


            if (this.state.iconsopen) // le menu du bas est ouvert
            {

                // Menu Texte Fermé
                for (var i=0 ; i < this.state.menu.length; i++)
                {
                    var cat = this.state.menu[i];
                    var text = getText(cat.text.cat,cat.text.scat,this.context.language);
                    if (cat.childs.length == 0)
                        menu.push(<IconSideBar values={cat} index={i} sindex={-1} text={text} selected={this.state.selected} onClick={this.onClickOnIcon} />);
                    else
                    {
                        for (var j=0; j<cat.childs.length; j++)
                            {
                                var scat = cat.childs[j];
                                text = getText(scat.text.cat,scat.text.scat,this.context.language);
                                menu.push(<IconSideBar values={cat.childs[j]} index={i} sindex={j} text={text} selected={this.state.selected} onClick={this.onClickOnIcon}/>);
                            }
        
                    }

                }
                tipmenu = getText(0,9,this.context.language);
            }
            else
            {
                // le menu du bas est fermé
                
            }
    
        }


        if (this.state.open)
        {
            return (
                <div className="divFullSideBar" >
                    <div className="divLeftSideBarOpen" ref={this.wrapperRef}>
                        <div className="divLeftSideBarOpenUp">
                            <div className="divMenuButtonSideBar">
                            </div>
                            <div className="divContentOpenSideBar">
                                {menu}
                            </div>
                        </div>
                        <div className="divLeftSideBarOpenDown">
                            <Icon image={logo} width="50%"/>
                        </div>
                        <div className="divBottomSideBarClose">
                            <Tooltip text= {tipmenu}>
                            &nbsp;&nbsp;&nbsp;<Button width="28px" height="28px" image={sidebarmenuclose} border={false} disable={false} onClick={this.onClickOnMenu}/>
                            </Tooltip>
                        </div>

                    </div>


                    <div className="divRightSideBarOpen">
                        {this.props.children}
                    </div>
                    {popup}
                </div>
            )
        }
        else
        {

            if (this.state.iconsopen)
            {
            return (
                //  menu icone du bas ouvert
                <div className="divFullSideBar" >
                    <div className="divLeftSideBarClose" ref={this.wrapperRef}>

                    </div>
                    <div className="divRightSideBarClose">
                        {this.props.children}
                    </div>

                    
                    
                        <div className="divBottomSideBarOpen" onMouseLeave={this.onLeaveMenuDown} >
                            <div className="IconOnlyFullFiv">
                            <div className="IconOnlyDiv">
                                <div className="IconOnlyDiv1">
                                {menu}
                                </div>
                            </div>
                            

                        </div>
                    </div>
                    <div className="MenuBoutonOpenClose">
                        <Tooltip text= {tipmenu}>
                        <Button width="28px" height="28px" image={sidebarmenuopen} border={false} disable={false} onClick={this.onClickOnMenu}/>
                        </Tooltip>
                    </div>
                    {popup}
                </div>)
            }
            else
            {
            return (
                // tous les menus fermés
                <div className="divFullSideBar" >
                    <div className="divLeftSideBarClose" ref={this.wrapperRef}>

                    </div>
                    <div className="divRightSideBarClose">
                        {this.props.children}
                    </div>
                    <div className="divBottomSideBarClose" >
                        <div className="divBottomSideBarClose1"></div>
                        <div className="divBottomSideBarClose2" onMouseEnter={this.onEnterMenuDown}></div>
                    </div>
                    <div className="MenuBoutonOpenClose">
                        <Tooltip text= {tipmenu}>
                        <Button width="28px" height="28px" image={sidebarmenuopen} border={false} disable={false} onClick={this.onClickOnMenu}/>
                        </Tooltip>
                    </div>
                    {popup}
                    
                </div>
                )
            }


            /*
            return (
                <div className="divFullSideBar" >
                    <div className="divLeftSideBarClose" ref={this.wrapperRef}>

                        <div className="divMenuButtonSideBar">
                            <Tooltip text= {tipmenu}>
                            <Button width="48px" height="48px" image={sidebarmenuopen} border={false} disable={false} onClick={this.onClickOnMenu}/>
                            </Tooltip>
                        </div>
                        <div className="divContentOpenSideBar">
                            {menu}
                        </div>
                    </div>
                    <div className="divRightSideBarClose">
                        {this.props.children}
                    </div>
                    {popup}
                </div>
                
            )
            */

        }
    }
};

export default SideBar;

